// NZ GST is a flat 15%. Budget/allocated/variance figures are stored
// GST-exclusive (see CONTEXT.md); when a user views in "incl" mode we gross
// them up by this rate purely for display. There is no per-line tax data on
// the budget, so the gross-up is always this flat rate — which keeps grossed
// figures internally consistent (grossed variance = grossed allocated − grossed
// budget). Stored data is never mutated by the lens.
export const GST_RATE = 0.15;

/** Gross up a GST-exclusive cents amount to its GST-inclusive equivalent. */
export function grossUpCents(cents: number): number {
  return Math.round(cents * (1 + GST_RATE));
}

/**
 * The GST-exclusive part of a GST-INCLUSIVE cents figure — the inverse of
 * `grossUpCents`. Used where the inclusive number is the source of truth
 * rather than a display lens: a bank outflow is cash that left the account, so
 * the exclusive figure the budget wants has to be derived back out of it
 * (SPL-177).
 */
export function exclFromInclCents(cents: number): number {
  return Math.round(cents / (1 + GST_RATE));
}
